import { useState } from "react";

// Loader type
export type Loader = {
  loading: boolean;
  error: boolean;
  setLoading: () => void;
  setError: () => void;
  setSuccess: () => void;
};

export const useLoader = (initialState: boolean): Loader => {
  const [state, setState] = useState({ loading: initialState, error: false });
  return {
    ...state,
    setLoading: () => setState({ loading: true, error: false }),
    setError: () => setState({ loading: false, error: true }),
    setSuccess: () => setState({ loading: false, error: false })
  };
};
